import * as Yup from 'yup';

import React, { useEffect, useMemo, useState } from 'react';
import {
  Container,
  Button,
  Box,
  Stack,
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
  Chip,
  IconButton,
  CircularProgress,
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import { useRazorpay } from 'react-razorpay';
import { clearRazorPayInfo } from '../../server/store/inspectionBooking';
import { RHFTextField } from '../../hooks';
import RHFPhoneField from '../../hooks/rhf-phone-input-new';
import { createBooking } from '../../server/api/inspectionBooking';
import { useDevice } from '../../hooks/useResponsive';
import { MetaHelmet } from '../../layouts/Helmet/Helmet';
import SubmitModal from '../popup';
import { getSettings } from '../../server/api/settings';

export default function InspectionBookingFormPage() {
  const { isMobile } = useDevice();
  const dispatch = useDispatch();

  const location = useLocation();

  const { selectedBrandId } = location.state || {};
  // console.log('selectedBrandId>>>>>>>', selectedBrandId);

  const { razorpayInfo, booking, bookingLoading, settings } = useSelector((state) => ({
    razorpayInfo: state.Inspection.razorpayInfo,
    razorpayLoading: state.Inspection.razorpayLoading,
    bookingLoading: state.Inspection.bookingLoading,
    booking: state.Inspection.booking,
    settings: state.settings.settings,
  }));
  // console.log(settings?.booking_option);
  const Razorpay = useRazorpay();

  useEffect(() => {
    const credentials = {
      dispatch,
    };
    dispatch(getSettings(credentials));
  }, [dispatch]);

  const [isWhatsappSame, setIsWhatsappSame] = useState(true);
  const [countryCode, setCountryCode] = useState('91');
  const [whatsappCountryCode, setWhatsappCountryCode] = useState('91');
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);

  const navigate = useNavigate();
  const [modal, setModal] = React.useState(false);

  const { watch, reset } = useForm({
    defaultValues: {
      name: '',
      phone: '',
      pincode: '',
      message: '',
    },
  });
  const phone = watch('phone');
  const expectedLength = countryCode === '968' ? 8 : 10;
  const showLengthError = phone && phone.length !== expectedLength;
  const defaultValues = useMemo(() => ({}), []);

  const FormSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    phone: Yup.string()
      .length(countryCode === '968' ? 8 : 10, `Phone number must be exactly ${countryCode === '968' ? 8 : 10} digits`)
      .required('Phone number is required'),
    whatsapp: Yup.string().when([], {
      is: () => !isWhatsappSame, // only required if user wants separate whatsapp
      then: (schema) =>
        schema
          .length(
            whatsappCountryCode === '968' ? 8 : 10,
            `Phone number must be exactly ${whatsappCountryCode === '968' ? 8 : 10} digits`
          )
          .required('WhatsApp number is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    // whatsapp: Yup.string()
    //   .min(10, 'Phone must be at least 10 characters')
    //   .max(15, 'Phone must not exceed 15 characters'),
    pincode: Yup.string(),
    address: Yup.string(),
    city: Yup.string(),

    payment_type: Yup.string(),
  });

  const methods = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues,
  });

  const onSubmit = async (value, e) => {
    e?.preventDefault();

    const baseState = {
      user_details: {
        name: value?.name,
        phone: value?.phone,
        address: value?.address,
        whatsapp: value?.whatsapp,
        pincode: value?.pincode,
        country_code: `+${countryCode}`,
        whatsapp_country_code: `+${whatsappCountryCode}`,
        city: value?.city,
      },
      vehicle_details: {
        brand: selectedBrandId?._id,
      },
      payment_type: selectedPaymentType,
      type: 'INSPECTION',
    };

    const credentials = {
      state: baseState,
      dispatch,
      reset,
      selectedBrandId,
      ...(selectedPaymentType === 'PAY_LATER' && { navigate }), // only add navigate for PAY_LATER
    };

    // console.log('credentials >>>>>', credentials);

    dispatch(createBooking(credentials));
  };
  useEffect(() => {
    if (razorpayInfo?.razorPayOrder) {
      dispatch(clearRazorPayInfo());
    }
  }, [dispatch, razorpayInfo?.razorPayOrder]);

  const razorpayOrderInfo = razorpayInfo?.razorPayOrder;

  // console.log('razorpayOrderInfo', razorpayOrderInfo);
  // console.log('booking', booking);
  useEffect(() => {
    if (razorpayOrderInfo?.id && razorpayOrderInfo?.amount) {
      initiateRazorpayPayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [razorpayOrderInfo?.id]);

  const initiateRazorpayPayment = () => {
    if (!Razorpay) {
      enqueueSnackbar('Razorpay not available', { variant: 'error' });
      return;
    }

    const options = {
      key: settings?.payment?.encrypted_key_id,
      amount: razorpayOrderInfo?.amount,
      currency: razorpayOrderInfo?.currency,
      order_id: razorpayOrderInfo?.id,
      prefill: {
        name: booking?.user_details?.name,
        // email: booking?.email,
        contact: booking?.user_details?.phone,
        description: booking?.description,
      },
      readonly: {
        email: true,
        contact: true,
      },
      // handler: async (res) => {
      //   console.log('response from razorpay', res);
      //   try {
      //     // dispatch(verifyRazorpayOrder(res));
      //     if (res.razorpay_payment_id) {
      //       if (challanInfo?._id) {
      //         navigate(`/challan-success-page/${challanInfo._id}`);
      //       }

      //       // router.push(paths.public.payment_successpage(purchase?._id));
      //     } else {
      //       navigate('/challan-fail-page');

      //       // router.push(paths.public.payment_failurepage(purchase?._id));
      //     }
      //   } catch (error) {
      //     enqueueSnackbar('payment verification failed, try again', { variant: 'error' });
      //     // router.push(paths.public.payment_failurepage(purchase?._id));
      //   }
      // },
      handler: async (res) => {
        console.log('response from razorpay', res);
        try {
          const storedBBokingData = JSON.parse(localStorage.getItem('bookingInfo'));

          if (res.razorpay_payment_id && storedBBokingData?._id) {
            console.log('Navigating to success with ID:', storedBBokingData._id);
            navigate(`/payment-success/${storedBBokingData._id}`);
            localStorage.removeItem('challanInfo');
          } else {
            console.warn('Missing challanInfo or payment ID');
            navigate(`/payment-fail/${storedBBokingData._id}`);
          }
        } catch (error) {
          enqueueSnackbar('Payment verification failed, try again', { variant: 'error' });
          navigate('/challan-fail-page');
        }
      },

      notes: {
        address: 'Focus Motors',
      },
      theme: {
        color: '#3399cc',
      },
    };

    const rzpay = new window.Razorpay(options);
    rzpay.open();
  };
  // const onSubmit = async (value, e) => {
  //   e?.preventDefault();
  //   console.log(value);
  //   const credentials = {
  //     state: {
  //       user_details: {
  //         name: value?.name,
  //         phone: value?.phone,
  //         address: value?.address,
  //         whatsapp: value?.whatsapp,
  //         pincode: value?.pincode,
  //         country_code: countryCode,
  //         whatsapp_country_code: whatsappCountryCode,

  //         city: value?.city,
  //       },
  //       vehicle_details: {
  //         brand: selectedBrandId,
  //       },
  //       payment_type: selectedPaymentType, // payment_type: payment,
  //     },
  //     dispatch,
  //     reset,
  //     navigate,
  //   };
  //   console.log('credentials >>>>>', credentials);
  //   dispatch(createBooking(credentials));
  // };
  // const paymentOptions = [
  //   { label: 'Online', value: 'ONLINE' },
  //   { label: 'Pay Later', value: 'PAY_LATER' },
  // ];

  return (
    <>
      <FormProvider {...methods}>
        <MetaHelmet title={'Dream Car Booking'} companyName={'Focus Motors'} />
        <SubmitModal open={modal} close={() => setModal(false)} />
        <Box className="bg-light " sx={{ paddingBottom: '120px' }}>
          <Container
            maxWidth="xl"
            sx={{
              padding: isMobile ? 'unset' : '0px 0px 500px 0px !important',
              position: 'relative',
              minHeight: !isMobile && '100vh',
              backgroundColor: '#f0f1f3',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: isMobile ? 150 : 500,
                backgroundImage: 'url(/assets/images/Inspection/VerifyBanner.webp)',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            />
            <Container
              maxWidth="md"
              sx={{
                position: 'absolute',
                top: isMobile ? 0 : '15%',
                left: '50%',
                transform: 'translateX(-50%)',
                borderRadius: isMobile ? 0 : '24px',
                backgroundColor: '#FFFFFF',
              }}
            >
              <Box mt={2}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                  <Box sx={{ xs: 1, sm: 2, md: 3, backgroundColor: 'white', p: isMobile ? 0 : 3, pb: 5 }}>
                    {/* Top Row */}
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ width: isMobile ? '100%' : '60%' }}
                      mb={3}
                    >
                      {/* Back Button */}
                      <Stack
                        direction="row"
                        alignItems="center"
                        onClick={() => navigate(-1)}
                        spacing={isMobile ? 0.5 : 1.2}
                        sx={{ cursor: 'pointer' }}
                      >
                        <IconButton size="small" sx={{ p: 0 }}>
                          <ArrowBackIosNewIcon sx={{ fontSize: '12px', color: '#121212' }} />
                        </IconButton>
                        <Typography fontSize={14} fontWeight={500} color="#121212">
                          Back
                        </Typography>
                      </Stack>

                      {/* Selected Brand */}
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography fontSize={14} color="#333333">
                          Selected Brand :
                        </Typography>
                        <Chip
                          label={`${selectedBrandId?.name || '---'}`}
                          size="small"
                          sx={{
                            borderRadius: '16px',
                            fontWeight: 400,
                            fontSize: '14px',
                            px: 1.5,
                            backgroundColor: '#fff',
                            color: '#333333',
                            border: '1px solid #3333336E',
                            height: 24,
                          }}
                        />
                      </Stack>
                    </Stack>

                    <Box
                      sx={{
                        maxWidth: '500px',
                        margin: 'auto',
                        bgcolor: '#fff',
                        borderRadius: '24px',
                        overflow: 'hidden',
                        pb: 1,
                        // boxShadow: 3,
                      }}
                    >
                      {/* Title with Rounded Dividers */}

                      <Box
                        sx={{
                          textAlign: 'center',
                          py: 2,
                          borderRadius: '24px',
                          border: '1px solid #33333333',
                          position: 'relative',
                          mt: isMobile ? 1 : 2,
                          pt: isMobile ? 0.5 : 2,
                          borderBottomColor: 'transparent',
                          borderRight: 'unset',
                          borderLeft: 'unset',
                        }}
                      >
                        <Typography
                          width="fit-content"
                          fontWeight={500}
                          backgroundColor="white"
                          position="absolute"
                          fontSize="16px"
                          sx={{ left: '50%', px: 1, transform: 'translateX(-50%)', top: '-12px', zIndex: 2 }}
                        >
                          User Details
                        </Typography>
                      </Box>
                      <Grid container spacing={isMobile ? 1.1 : 2} mb={isMobile && 5}>
                        <Grid item xs={12} sm={12}>
                          <Typography fontSize={14} fontWeight={400} color="#1C252E">
                            Name{' '}
                            <Box component="span" sx={{ color: 'red' }}>
                              *
                            </Box>
                          </Typography>
                          <RHFTextField
                            name="name"
                            placeholder="Enter Your Name"
                            fullWidth
                            required
                            className="custom-inspection-textfield"
                            InputLabelProps={{ shrink: false }}
                            sx={{
                              '& .MuiInputBase-input': {
                                fontSize: '16px !important',
                              },
                            }}
                          />
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                        <Typography fontSize={14} fontWeight={400} color="#1C252E">
                          Whatsapp{' '}
                        </Typography>
                        <RHFTextField
                          className="custom-inspection-textfield"
                          name="whatsapp"
                          placeholder="Enter Whatsapp  Number"
                          // label="Whatsapp Number"
                          type="number"
                          fullWidth
                        />
                      </Grid> */}

                        <Grid item xs={12}>
                          <Typography fontSize={14} fontWeight={400} color="#1C252E">
                            Phone{' '}
                            <Box component="span" sx={{ color: 'red' }}>
                              *
                            </Box>
                          </Typography>
                          <Stack spacing={1}>
                            <RHFPhoneField
                              name="phone"
                              placeholder="Enter Phone Number"
                              required
                              countryCode={countryCode}
                              setCountryCode={setCountryCode}
                              sx={{
                                '& .MuiInputBase-input': {
                                  fontSize: '16px !important',
                                },
                              }}
                            />

                            <Typography variant="caption" color={showLengthError ? 'error' : 'text.secondary'}>
                              {showLengthError && (
                                <span style={{ marginBottom: 2 }}>
                                  Phone number must be exactly {expectedLength} digits
                                </span>
                              )}
                            </Typography>
                          </Stack>
                          <Box ml={2.5} mt={0.7}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isWhatsappSame}
                                  onChange={(e) => setIsWhatsappSame(e.target.checked)}
                                  sx={{
                                    color: '#34C38F',
                                    '&.Mui-checked': { color: '#34C38F' },
                                    p: 0.5,
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 18,
                                      width: 18,
                                      height: 18,
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography fontSize={14} fontWeight={400} mt={0.5} color="#1C252E">
                                  This is my WhatsApp number
                                </Typography>
                              }
                            />
                          </Box>
                        </Grid>

                        {!isWhatsappSame && (
                          <Grid item xs={12}>
                            <Typography fontSize={14} fontWeight={400} color="#1C252E">
                              Whatsapp
                            </Typography>
                            <Stack spacing={1}>
                              <RHFPhoneField
                                name="whatsapp"
                                placeholder="Enter Whatsapp Number"
                                required
                                countryCode={whatsappCountryCode}
                                setCountryCode={setWhatsappCountryCode}
                                sx={{
                                  '& .MuiInputBase-input': {
                                    fontSize: '16px !important',
                                  },
                                }}
                              />

                              <Typography variant="caption" color={showLengthError ? 'error' : 'text.secondary'}>
                                {showLengthError && <span>Phone number must be exactly {expectedLength} digits</span>}
                              </Typography>
                            </Stack>
                          </Grid>
                        )}
                        <Grid item xs={7.2} sm={6}>
                          <Typography fontSize={14} fontWeight={400} color="#1C252E">
                            City
                          </Typography>
                          <RHFTextField
                            name="city"
                            className="custom-inspection-textfield"
                            // label="City"
                            type="text"
                            placeholder="Enter City Name"
                            fullWidth
                            sx={{
                              '& .MuiInputBase-input': {
                                fontSize: '16px !important',
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={4.8} sm={6}>
                          <Typography fontSize={14} fontWeight={400} color="#1C252E">
                            Pincode
                          </Typography>
                          <RHFTextField
                            name="pincode"
                            // label="PIN Code"
                            // type="number"
                            size="small"
                            placeholder="Enter Pincode"
                            className="custom-inspection-textfield"
                            fullWidth
                            sx={{
                              '& .MuiInputBase-input': {
                                fontSize: '16px !important',
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography fontSize={14} fontWeight={400} color="#1C252E">
                            Address
                          </Typography>
                          <RHFTextField
                            name="address"
                            className="custom-inspection-textfield custom-inspection-textfield-multiline"
                            // label="Address"
                            placeholder="Enter Address"
                            multiline
                            rows={1}
                            fullWidth
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            sx={{
                              width: '100%',
                              bgcolor: '#f8f7e2',
                              border: ' 0.5px solid #E4E4DB',
                              borderRadius: '8px',
                              px: 2,
                              py: 1.5,
                              display: 'flex',
                              flexDirection: isMobile ? 'column' : 'row',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <Typography variant="body2" color="#1C252E">
                                Inspection Charge
                              </Typography>
                              <Box textAlign="right">
                                <Typography fontSize={20} fontWeight={600} color="#121212">
                                  ₹{' '}
                                  {selectedBrandId?.inspection_charge?.offer_price ??
                                    selectedBrandId?.inspection_charge?.price ??
                                    0}
                                </Typography>
                                <Typography fontSize={12} color="#1C252E">
                                  (including GST)
                                </Typography>
                                {!isMobile && (
                                  <Typography fontSize={isMobile ? 9 : 10} color="#1C252E">
                                    Additional travel charge applicable only above 100 KMs.{' '}
                                  </Typography>
                                )}
                              </Box>
                            </Box>

                            {isMobile && (
                              <Typography fontSize={isMobile ? 10 : 10} mt={1} color="#1C252E">
                                Additional travel charge applicable only above 100 KMs.{' '}
                              </Typography>
                            )}
                          </Box>
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                          <Button
                            type="submit"
                            onClick={() => setSelectedPaymentType('ONLINE')}
                            fullWidth
                            disabled={
                              !(
                                (selectedBrandId?.inspection_charge?.offer_price &&
                                  selectedBrandId.inspection_charge.offer_price > 0) ||
                                (selectedBrandId?.inspection_charge?.price &&
                                  selectedBrandId.inspection_charge.price > 0)
                              )
                            }
                            sx={{
                              borderRadius: '999px',
                              textTransform: 'none',
                              fontWeight: 700,
                              mt: !isMobile && 1,
                              fontSize: isMobile ? 14 : 14,
                              px: !isMobile && 7,
                              py: isMobile ? 1 : 0.7,
                              lineHeight: !isMobile && '18px',
                              background: 'linear-gradient(90deg, #FF9910 0%, #F16400 100%)',
                              color: 'white',
                              '&:hover': {
                                background: 'linear-gradient(90deg, #F16400 0%, #FF9910 100%)',
                              },
                              '&.Mui-disabled': {
                                background: '#ccc',
                                color: '#666',
                              },
                            }}
                          >
                            {bookingLoading ? (
                              <CircularProgress size={24} sx={{ color: '#fff' }} />
                            ) : (
                              <>
                                Pay ₹
                                {selectedBrandId?.inspection_charge?.offer_price ??
                                  selectedBrandId?.inspection_charge?.price ??
                                  0}{' '}
                                and Book Inspection
                              </>
                            )}
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Button
                            type="submit"
                            fullWidth
                            onClick={() => setSelectedPaymentType('PAY_LATER')}
                            variant="outlined"
                            sx={{
                              borderRadius: '999px',
                              textTransform: 'none',
                              fontWeight: 700,
                              fontSize: 14,
                              height: isMobile ? '100%' : '85%',
                              maxHeight: '60px',
                              py: 1,
                              mt: !isMobile && 1,
                              borderWidth: '1px',
                              borderColor: '#FF9910',
                              color: '#F16400',
                              '&:hover': {
                                borderColor: '#F16400',
                                backgroundColor: 'rgba(255,153,16,0.05)',
                              },
                            }}
                          >
                            {bookingLoading ? (
                              <CircularProgress size={24} sx={{ color: '#342C2C' }} />
                            ) : (
                              'Book Now, Pay Later'
                            )}
                          </Button>
                        </Grid> */}
                        <Grid
                          container
                          spacing={isMobile ? 1.1 : 2}
                          mt={isMobile && 0}
                          sx={{ pl: isMobile ? '10px !important' : '20px !important' }}
                        >
                          {/* If BOTH */}
                          {settings?.booking_option === 'both' && (
                            <>
                              {/* ONLINE button */}
                              <Grid item xs={12} sm={6}>
                                <Button
                                  type="submit"
                                  onClick={() => setSelectedPaymentType('ONLINE')}
                                  fullWidth
                                  disabled={
                                    !(
                                      (selectedBrandId?.inspection_charge?.offer_price &&
                                        selectedBrandId.inspection_charge.offer_price > 0) ||
                                      (selectedBrandId?.inspection_charge?.price &&
                                        selectedBrandId.inspection_charge.price > 0)
                                    )
                                  }
                                  sx={{
                                    borderRadius: '999px',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    mt: !isMobile && 1,
                                    fontSize: 14,
                                    px: !isMobile && 7,
                                    py: isMobile ? 1 : 0.7,
                                    lineHeight: !isMobile && '18px',
                                    background: 'linear-gradient(90deg, #FF9910 0%, #F16400 100%)',
                                    color: 'white',
                                    '&:hover': {
                                      background: 'linear-gradient(90deg, #F16400 0%, #FF9910 100%)',
                                    },
                                    '&.Mui-disabled': {
                                      background: '#ccc',
                                      color: '#666',
                                    },
                                  }}
                                >
                                  {bookingLoading ? (
                                    <CircularProgress size={24} sx={{ color: '#fff' }} />
                                  ) : (
                                    <>
                                      Pay ₹
                                      {selectedBrandId?.inspection_charge?.offer_price ??
                                        selectedBrandId?.inspection_charge?.price ??
                                        0}{' '}
                                      and Book Inspection
                                    </>
                                  )}
                                </Button>
                              </Grid>

                              {/* PAY LATER button */}
                              <Grid item xs={12} sm={6}>
                                <Button
                                  type="submit"
                                  fullWidth
                                  onClick={() => setSelectedPaymentType('PAY_LATER')}
                                  variant="outlined"
                                  sx={{
                                    borderRadius: '999px',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    fontSize: 14,
                                    height: isMobile ? '100%' : '85%',
                                    maxHeight: '60px',
                                    py: 1,
                                    mt: !isMobile && 1,
                                    borderWidth: '1px',
                                    borderColor: '#FF9910',
                                    color: '#F16400',
                                    '&:hover': {
                                      borderColor: '#F16400',
                                      backgroundColor: 'rgba(255,153,16,0.05)',
                                    },
                                  }}
                                >
                                  {bookingLoading ? (
                                    <CircularProgress size={24} sx={{ color: '#342C2C' }} />
                                  ) : (
                                    'Book Now, Pay Later'
                                  )}
                                </Button>
                              </Grid>
                            </>
                          )}

                          {/* If ONLY PAY_LATER */}
                          {settings?.booking_option === 'pay_later' && (
                            <Grid item xs={12}>
                              <Button
                                type="submit"
                                fullWidth
                                onClick={() => setSelectedPaymentType('PAY_LATER')}
                                variant="outlined"
                                sx={{
                                  borderRadius: '999px',
                                  textTransform: 'none',
                                  fontWeight: 700,
                                  fontSize: 14,
                                  height: isMobile ? '100%' : '85%',
                                  maxHeight: '60px',
                                  py: 1,
                                  mt: !isMobile && 1,
                                  borderWidth: '1px',
                                  borderColor: '#FF9910',
                                  color: '#F16400',
                                  '&:hover': {
                                    borderColor: '#F16400',
                                    backgroundColor: 'rgba(255,153,16,0.05)',
                                  },
                                }}
                              >
                                {bookingLoading ? (
                                  <CircularProgress size={24} sx={{ color: '#342C2C' }} />
                                ) : (
                                  'Book Now, Pay Later'
                                )}
                              </Button>
                            </Grid>
                          )}

                          {/* If ONLY ONLINE */}
                          {settings?.booking_option === 'online_booking' && (
                            <Grid item xs={12}>
                              <Button
                                type="submit"
                                onClick={() => setSelectedPaymentType('ONLINE')}
                                fullWidth
                                disabled={
                                  !(
                                    (selectedBrandId?.inspection_charge?.offer_price &&
                                      selectedBrandId.inspection_charge.offer_price > 0) ||
                                    (selectedBrandId?.inspection_charge?.price &&
                                      selectedBrandId.inspection_charge.price > 0)
                                  )
                                }
                                sx={{
                                  borderRadius: '999px',
                                  textTransform: 'none',
                                  fontWeight: 700,
                                  mt: !isMobile && 1,
                                  fontSize: 14,
                                  px: !isMobile && 7,
                                  py: isMobile ? 1 : 0.7,
                                  minHeight: '45px',
                                  lineHeight: !isMobile && '18px',
                                  background: 'linear-gradient(90deg, #FF9910 0%, #F16400 100%)',
                                  color: 'white',
                                  '&:hover': {
                                    background: 'linear-gradient(90deg, #F16400 0%, #FF9910 100%)',
                                  },
                                  '&.Mui-disabled': {
                                    background: '#ccc',
                                    color: '#666',
                                  },
                                }}
                              >
                                {bookingLoading ? (
                                  <CircularProgress size={24} sx={{ color: '#fff' }} />
                                ) : (
                                  <>
                                    Pay ₹
                                    {selectedBrandId?.inspection_charge?.offer_price ??
                                      selectedBrandId?.inspection_charge?.price ??
                                      0}{' '}
                                    and Book Inspection
                                  </>
                                )}
                              </Button>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </form>
              </Box>
            </Container>
          </Container>
        </Box>
      </FormProvider>
    </>
  );
}
